import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const VerifyEmailChangePage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [username, setUsername] = useState('');
  const [newEmail, setNewEmail] = useState('');

  useEffect(() => {
    const verifyEmailChange = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setMessage('認証トークンが見つかりません');
        setIsLoading(false);
        return;
      }

      try {
        const response = await axios.post('/api/auth/verify-email-change', { token });

        setMessage(response.data.message);
        setCompanyName(response.data.companyName);
        setUsername(response.data.username);
        setNewEmail(response.data.newEmail);
        setIsSuccess(true);
      } catch (error: any) {
        setMessage(error.response?.data?.error || 'メールアドレス変更確認に失敗しました');
        setIsSuccess(false);
      } finally {
        setIsLoading(false);
      }
    };

    verifyEmailChange();
  }, [searchParams]);

  return (
    <div style={{ maxWidth: '500px', margin: '50px auto', padding: '20px' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '30px' }}>メールアドレス変更</h1>

      {isLoading ? (
        <div style={{
          textAlign: 'center',
          padding: '40px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px'
        }}>
          <p>確認中...</p>
        </div>
      ) : (
        <div style={{
          padding: '20px',
          marginBottom: '20px',
          borderRadius: '8px',
          backgroundColor: isSuccess ? '#d4edda' : '#f8d7da',
          color: isSuccess ? '#155724' : '#721c24',
          border: `1px solid ${isSuccess ? '#c3e6cb' : '#f5c6cb'}`
        }}>
          <p style={{ whiteSpace: 'pre-line' }}>{message}</p>

          {isSuccess && (
            <div style={{ marginTop: '20px' }}>
              <p><strong>企業名:</strong> {companyName}</p>
              <p><strong>ログインID:</strong> {username}</p>
              <p><strong>新しいメールアドレス:</strong> {newEmail}</p>
            </div>
          )}
        </div>
      )}

      {!isLoading && (
        <button
          onClick={() => navigate('/login')}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold'
          }}
        >
          {isSuccess ? 'ログイン画面へ' : 'ログイン画面に戻る'}
        </button>
      )}
    </div>
  );
};

export default VerifyEmailChangePage;
